import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, Input, Button, Card } from 'antd';
import { ArrowLeftOutlined, CheckOutlined, CloseCircleOutlined } from '@ant-design/icons';
// import image1 from 'assets/images/image1.png';
import logo from 'assets/images/logo.png';
// actions
import { validateEmail } from 'requests/auth';
import { forgotPassword } from 'requests/auth';

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null);
    const [inputIcon, setInputIcon] = useState(null);
    const [message, setMessage] = useState('');

    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (status === 'success') setInputIcon(<CheckOutlined />);
        else if (status === 'failed') setInputIcon(<CloseCircleOutlined />);
    }, [status]);

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            await validateEmail(data);
            setStatus('success');
            setMessage(<div className="input-message-success">{t('reset_link_was_sent')}</div>);
            await forgotPassword(data);
            navigate('/check-email', { replace: true });
        } catch (err) {
            console.log(err);
            setStatus('failed');
            setMessage(<div className="input-message-failed">{t('enter_valid_email')}</div>);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="form-signin mt-121">
            <img className="logo" src={logo} alt="" />
            <h3>{t('forgot_password')}</h3>
            <p>{t('text_email_account')}</p>
            <Card className="card-input card-border mt-32">
                <Form layout="vertical" onFinish={onSubmit}>
                    <Form.Item
                        name="email"
                        label={t('email_address')}
                        extra={message}
                        className="password-forgot mb-48"
                    >
                        <Input className={`input--${status}`} placeholder={t('input_email')} suffix={inputIcon} />
                    </Form.Item>

                    <Button className="authentication-btn" type="primary" htmlType="submit" loading={loading}>
                        {t('send')}
                    </Button>
                </Form>
            </Card>
            <Link to={'/signin'} className="btn-back mt-40">
                <ArrowLeftOutlined /> {t('back')}{' '}
            </Link>
        </div>
    );
};

export default ForgotPassword;
